import { Environment } from "./environment.js";
import { allEnumValues, isValidEnumValue } from "./helper.js";
//#region src/environment_helper.ts
var EnvironmentHelper = class {
	static current() {
		const env = process.env.APP_ENV;
		if (!env) throw new Error("APP_ENV is not set!!!");
		if (!isValidEnumValue(Environment, env)) throw new Error(`Invalid APP_ENV set: ${env}`);
		return env;
	}
	static isCurrentDev(env = this.current()) {
		return ["dev"].includes(env);
	}
	static isCurrentTest(env = this.current()) {
		return env === "test";
	}
	static isCurrentProd(env = this.current()) {
		return env === "prod";
	}
	static isCurrentProdOrStaging(env = this.current()) {
		return env === "prod" || env === "staging";
	}
	static isCurrentStagingOrSandbox(env = this.current()) {
		return env === "staging" || env === "sandbox";
	}
	static isHosting(env) {
		return !this.isDevOrTest(env);
	}
	static isDevOrTest(env) {
		switch (env) {
			case "prod":
			case "staging":
			case "sandbox": return false;
			case "dev":
			case "test": return true;
		}
	}
	static hostingEnvironments() {
		return allEnumValues(Environment).filter((env) => {
			return !this.isDevOrTest(env);
		});
	}
	/**
	* Returns the Porter preview PR number if available.
	*
	* This is intentionally written to work in BOTH:
	* - Node/server environments (where `process.env.PORTER_PR_NUMBER` may be set)
	* - Browser environments (where our bundlers may not polyfill `process`, but we may inject
	*   `__PORTER_PR_NUMBER__` onto `globalThis`, or infer it from the hostname: `pr-<num>-...`).
	*
	* If no PR number is detected, returns an empty string.
	*/
	static porterPrNumber() {
		const globals = typeof globalThis !== "undefined" ? globalThis : {};
		const prFromProcess = globals?.process?.env?.PORTER_PR_NUMBER;
		if (typeof prFromProcess === "string") {
			const pr = prFromProcess.trim();
			if (pr.length > 0) return pr;
		}
		const prFromGlobal = globals?.["__PORTER_PR_NUMBER__"];
		if (typeof prFromGlobal === "string") {
			const pr = prFromGlobal.trim();
			if (pr.length > 0) return pr;
		}
		return "";
	}
	static isPreview() {
		return this.porterPrNumber().trim().length > 0;
	}
};
//#endregion
export { EnvironmentHelper };

//# sourceMappingURL=environment_helper.js.map